var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadSpreadsheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 53,
    viewBox: "0 0 73 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.315 52.065 4.292-16.604c0-5.503-4.43-9.965-9.897-9.965H39.94c-5.465 0-9.897 4.462-9.897 9.965v16.604h29.272z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.242 30.874-.892 2.169c0 .001-8.829 14.929-9.987 19.592h13.185l5.606-15.056s2.031-2.912 3.889-6.202c1.858-3.29.518-6.123.066-7.777s-1.654-2.175-1.654-2.175.133-1.172-.143-1.665c-.276-.493-2.202-2.19-2.202-2.19s-1.3-2.063-1.493-2.508c-.192-.445-.9-.368-.9-.368s-.337-.974-.57-1.052c-.234-.077-.827.344-1.136 1.284-.308.94 1.227 3.842 1.163 4.643-.064.8-.695 3.53-2.064 5.243-.77.964-1.755 1.34-2.163.884-.407-.457-1.991-3.15-2.435-3.738-.443-.589-1.4-.466-1.345-.268.054.198.736 3.212 1.195 5.15.458 1.937 1.88 4.034 1.88 4.034",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.242 30.874-.892 2.169c0 .001-8.829 14.929-9.987 19.592h13.185l5.606-15.056h0s2.031-2.912 3.889-6.202c1.858-3.29.518-6.123.066-7.777s-1.654-2.175-1.654-2.175.133-1.172-.143-1.665c-.276-.493-2.202-2.19-2.202-2.19s-1.3-2.063-1.493-2.508c-.192-.445-.9-.368-.9-.368s-.337-.974-.57-1.052c-.234-.077-.827.344-1.136 1.284-.308.94 1.227 3.842 1.163 4.643-.064.8-.695 3.53-2.064 5.243-.77.964-1.755 1.34-2.163.884-.407-.457-1.991-3.15-2.435-3.738-.443-.589-1.4-.466-1.345-.268.054.198.736 3.212 1.195 5.15.458 1.937 1.88 4.034 1.88 4.034zM69.094 25.796l-5.464-3.709",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.545 23.18s-2.489-.624-2.326-2.024c.022-.188 2.236.27 2.236.27M67.137 17.653l-1.821-.685c-.235-.059-.327.81-.23 1.033.177.4.514.947 1.133 1.349 1.095.71 1.76 1.697 1.76 1.697M64.717 14.695s-.516.57-.367 1.115c.15.546.667 1.514.667 1.514M65.475 23.168l.384-2.669-.03-1.415M67.219 24.331l.244-2.052M68.667 25.398l.237-2.353",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.524 52.652H9.118c-.8 0-1.516-.504-1.79-1.262L1.386 34.952c-.452-1.251.468-2.574 1.79-2.574h31.406c.8 0 1.516.504 1.79 1.262l5.942 16.438c.452 1.251-.468 2.574-1.79 2.574",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.524 52.652H9.118c-.8 0-1.516-.504-1.79-1.262L1.386 34.952c-.452-1.251.468-2.574 1.79-2.574h31.406c.8 0 1.516.504 1.79 1.262l5.942 16.438c.452 1.251-.468 2.574-1.79 2.574z",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.054 52.652-.312-.863a1.906 1.906 0 0 0-1.79-1.262H16.545c-1.165 0-2.016 1.026-1.894 2.125h35.402z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.054 52.652-.312-.863a1.906 1.906 0 0 0-1.79-1.262H16.545c-1.165 0-2.016 1.026-1.894 2.125h35.402z",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.254 53H7.848c-.8 0-1.516-.521-1.79-1.304L.117 34.71c-.453-1.292.467-2.66 1.79-2.66h31.405c.801 0 1.517.522 1.79 1.305l5.942 16.985c.453 1.293-.467 2.66-1.79 2.66",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.076 42.212c.387 1.072-.161 1.94-1.226 1.94-1.064 0-2.24-.868-2.628-1.94-.388-1.072.161-1.94 1.225-1.94 1.065 0 2.241.868 2.629 1.94",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.076 42.212c.387 1.072-.161 1.94-1.226 1.94-1.064 0-2.24-.868-2.628-1.94-.388-1.072.161-1.94 1.225-1.94 1.065 0 2.241.868 2.629 1.94z",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.851 14.847 3.205 11.948s-1.885 4.088-6.761 3.566c-.098-.01-1.78-12.24-1.78-12.24l5.336-3.274z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.851 14.847 3.205 11.948s-1.885 4.088-6.761 3.566c-.098-.01-1.78-12.24-1.78-12.24l5.336-3.274z",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.422 10.329.635 4.799a14.247 14.247 0 0 0 2.747 6.71l1.786 2.368s5.869-1.466 8.715-7.37c2.846-5.903-2.595-15.755-13.883-6.507",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.422 10.329.635 4.799a14.247 14.247 0 0 0 2.747 6.71l1.786 2.368s5.869-1.466 8.715-7.37c2.846-5.903-2.595-15.755-13.883-6.507z",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.849 12.48c-1.226-.779-2.645.304-2.76 1.024M40.473 10.379c-1.226-.779-2.644.304-2.76 1.023",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.783 14.765c.098.298.35.48.563.41.213-.072.305-.372.207-.67-.1-.297-.351-.48-.564-.409-.213.072-.305.371-.206.669M34.105 16.423c.099.298.351.481.564.41.212-.072.305-.371.206-.668-.099-.298-.35-.481-.564-.41-.212.072-.305.37-.206.668",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.682 13.718a2.16 2.16 0 0 1 2.639 1.552 2.177 2.177 0 0 1-1.542 2.657 2.16 2.16 0 0 1-2.64-1.552 2.177 2.177 0 0 1 1.543-2.657z",
    stroke: "#6176F4",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m36.398 12.094 1.295 6.376 1.753-.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6176F4",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m36.233 15.085 1.315-.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.365 9.057.345 4.372 3.232-1.884 1.363 5.292s3.349-2.836 1.95-7.885c-1.721-6.217-15.607-7.951-15.607-7.951s-4.61-.18-4.833 4.595c-.159 3.427 1.855 6.26 5.445 5.3 3.591-.96 8.105-1.84 8.105-1.84",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.578 13.037a2.095 2.095 0 0 1 .903-2.809 2.067 2.067 0 0 1 2.79.91 2.094 2.094 0 0 1-.904 2.808",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.578 13.037a2.095 2.095 0 0 1 .903-2.809 2.067 2.067 0 0 1 2.79.91 2.094 2.094 0 0 1-.904 2.808",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.862 13.032a2.18 2.18 0 0 1-1.29 2.79 2.157 2.157 0 0 1-2.77-1.3 2.18 2.18 0 0 1 1.29-2.79 2.157 2.157 0 0 1 2.77 1.3z",
    stroke: "#6176F4",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.265 20.85s2.336.294 3.815-1.963",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 20.344a9.307 9.307 0 0 1-13.226 0c-3.652-3.677-3.652-9.64 0-13.316a9.306 9.306 0 0 1 13.226 0c3.652 3.677 3.652 9.639 0 13.316z",
    stroke: "#080717",
    strokeWidth: 4.444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 7.027c3.652 3.678 3.652 9.64 0 13.317a9.306 9.306 0 0 1-13.226 0",
    stroke: "#6176F4",
    strokeWidth: 6.111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.087 4.27c5.165 0 9.352 4.215 9.352 9.416",
    stroke: "#3451FA",
    strokeWidth: 8.332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.11 24.812s2.644 1.757 2.499 5.407",
    stroke: "#000",
    strokeWidth: 0.655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSpreadsheet);
export default __webpack_public_path__ + "static/media/upload-spreadsheet.bb8332464b7835f5ca735d8bb491b079.svg";
export { ForwardRef as ReactComponent };